module.exports = __webpack_public_path__ + "static/media/sa.9cc53fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sa.png
// module id = 1890
// module chunks = 0